import { render, staticRenderFns } from "./mzDrugZJBank.vue?vue&type=template&id=447d82c4&scoped=true"
import script from "./mzDrugZJBank.vue?vue&type=script&lang=js"
export * from "./mzDrugZJBank.vue?vue&type=script&lang=js"
import style0 from "./mzDrugZJBank.vue?vue&type=style&index=0&id=447d82c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447d82c4",
  null
  
)

export default component.exports